// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"457":"7d2c3a0d","492":"69a25bb5"}[chunkId] + ".chunk.css";
};